import { render, staticRenderFns } from "./OptionsText.vue?vue&type=template&id=c34d49a6&"
import script from "./OptionsText.vue?vue&type=script&lang=js&"
export * from "./OptionsText.vue?vue&type=script&lang=js&"
import style0 from "./OptionsText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports